import Base from './action-base'
import renderFields from './qr-scan.pug'

export default class QrScan extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-qrcode"

  @DEFAULTS:
    instanceId: null

  renderFields: renderFields
